import {EmbedCodeBase} from '../types';

export const getBaseAdFoxStatEventPayload = ({
  containerId,
  code,
}: {
  containerId: string;
  code: EmbedCodeBase;
}) => ({
  container_id: containerId,
  creative_id: [code.params.p1, code.params.p2].join('_'),
});
